import get from "lodash/get";
import React from "react";
import { getStoryElementByType, getStoryElementsByType } from "../../../utils";
import Profile from "../Profile";
import "./profiles.m.css";

const Profiles = ({ card, cdnImage }) => {
  const title = get(getStoryElementByType(card, "title"), "text", "");
  const profiles = getStoryElementsByType(card, "image");
  const id = get(card, ["metadata", "attributes", "menuname", "0"], "");
  return (
    <div styleName="profiles-container" data-model-id="13963:54283" id={`${id.toLowerCase()}`}>
      <div styleName="profiles-description" dangerouslySetInnerHTML={{ __html: title }} />

      <div styleName="divider" />

      <div styleName="profiles-wrapper">
        {profiles.map((profile, index) => (
          <Profile
            image={`${cdnImage}/${profile["image-s3-key"]}`}
            name={profile.title}
            role={profile["image-attribution"]}
            divider={index !== profiles.length - 1}
          />
        ))}
      </div>
    </div>
  );
};

export default Profiles;
